import Form from './form'

export default {
  svg: 'clock',
  label: 'Time of Day',
  type: 'control',
  action: 'timeofday',
  form: Form
}
